/* eslint-disable max-lines-per-function */
import { Button } from 'primereact/button'
import { Calendar } from 'primereact/calendar'
import { Dropdown } from 'primereact/dropdown'
import { Tag } from 'primereact/tag'
import { Toolbar } from 'primereact/toolbar'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Table from '../components/layout/Table'
import vanBangBanSaoState, { getVanBangBanSaoState } from '../constant/vanBangBanSaoState'
import userProcessor from '../processor/userProcessor'
import vanBangBanSaoProcessor from '../processor/vanBangBanSaoProcessor'
import { setUsers } from '../store/reducer/user'
import store from '../store/store'
import { dateToDDMMYY } from '../utils/date'
import { exportExcel } from '../utils/excel'

const date = new Date()
const y = date.getFullYear()
const m = date.getMonth()
const firstDay = new Date(y, m, 1)
const lastDay = new Date(y, m + 1, 0)

const states = Object.keys(vanBangBanSaoState).map((key) => {
  return { id: vanBangBanSaoState[key], name: getVanBangBanSaoState(vanBangBanSaoState[key]) }
})

const mappingExport = {
  soHieuCu: 'Số hiệu cũ',
  soHieu: 'Số hiệu mới',
  soVaoSo: 'Số vào sổ',
  soBan: 'Số bản',
  ngayTao: 'Ngày tạo',
  nguoiDuyetName: 'Người duyệt',
}

const LichSuCapPhat = () => {
  const { users } = useSelector((state) => state.user)
  const [datas, setDatas] = useState([])
  const [from, setFrom] = useState(firstDay)
  const [to, setTo] = useState(lastDay)
  const [state, setState] = useState(0)
  const getUsers = async () => {
    const rs = await userProcessor.getAll()
    store.dispatch(setUsers(rs))
  }
  const getDatas = async () => {
    const rs = await vanBangBanSaoProcessor.getByDate(from.toUTCString(), to.toUTCString(), state)
    setDatas(rs)
  }
  useEffect(async () => {
    getDatas()
  }, [from, to, state])
  useEffect(async () => {
    getUsers()
  }, [])
  const columnTable = [
    {
      value: 'soHieuBanChinh',
      name: 'Số hiệu cũ',
      render: (item) => item.vanBang && item.vanBang.soHieu,
    },
    { value: 'soHieu', name: 'Số hiệu mới' },
    { value: 'soVaoSo', name: 'Số vào sổ' },
    { value: 'soBan', name: 'Số bản cấp' },
    {
      value: 'ngayTao',
      name: 'Ngày tạo',
      render: (item) => {
        return dateToDDMMYY(new Date(item.ngayTao))
      },
    },
    {
      value: 'nguoiDuyetId',
      name: 'Người duyệt',
      render: (item) => {
        const user = users.find((u) => u.id === item.nguoiDuyetId)
        return user ? user.fullname : ''
      },
    },
    {
      value: 'trangThai',
      name: 'Trạng thái',
      render: (item) => (
        <Tag
          severity={item.trangThai === vanBangBanSaoState.choDuyet ? 'danger' : ''}
          value={getVanBangBanSaoState(item.trangThai)}
        />
      ),
    },
  ]
  return (
    <>
      <div className="flex justify-content-between">
        <h4>Báo cáo lịch sử cấp phát</h4>
        <div>
          <Button
            icon="pi pi-file-excel"
            className="p-button-success"
            onClick={() =>
              exportExcel(
                datas.map((item) => {
                  return {
                    ...item,
                    soHieuCu: item.vanBang.soHieu,
                    nguoiDuyetName: item.nguoiDuyet.fullname,
                    ngayTao: dateToDDMMYY(new Date(item.ngayTao)),
                  }
                }),
                'BaoCaoLichSuCapPhat',
                mappingExport,
              )
            }
            disabled={datas.length === 0}
            label="Xuất excel"
          />
        </div>
      </div>
      <div className="card">
        <Toolbar
          className="mb-4"
          right={
            <div className="flex vanbang-seacher-cotainer">
              <div className="mr-2 mb-2">
                <Dropdown
                  optionValue="id"
                  optionLabel="name"
                  value={state}
                  onChange={(e) => setState(e.value)}
                  options={states}
                />
              </div>
              <div className="mr-2 mb-2 flex align-items-center">
                <b className="mr-1">Từ ngày:</b>
                <Calendar
                  showIcon
                  showButtonBar
                  dateFormat="dd/mm/yy"
                  placeholder="Từ ngày"
                  value={from}
                  onChange={(e) => setFrom(e.value)}
                />
              </div>
              <div className="mr-2 mb-2 flex align-items-center">
                <b className="mr-1">Đến ngày:</b>
                <Calendar
                  showIcon
                  showButtonBar
                  dateFormat="dd/mm/yy"
                  placeholder="Đến ngày"
                  value={to}
                  onChange={(e) => setTo(e.value)}
                />
              </div>
            </div>
          }
        />
        <Table data={datas} column={columnTable} />
      </div>
    </>
  )
}
export default LichSuCapPhat
